'use strict'

export const types = ['primary', 'info', 'success', 'danger', 'warning', 'grey', 'white']
